export default __webpack_public_path__ + "static/productInfoManagementVp5-af53a928145de7eddc979a6f4cde903f.png";